<script>
  'use strict'

  import { Radar, mixins } from 'vue-chartjs'

  const { reactiveProp } = mixins

  export default {
    extends: Radar,

    mixins: [reactiveProp],

    props: ['chartData', 'options'],

    mounted () {
      this.renderChart(this.chartData, this.options)
    },

    watch: {
      options: {
        handler: function (newVal, oldVal) {
          this.renderChart(this.chartData, this.options)
        },
        deep: true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/vue-chart/charts/radar.vue